<template>
  <!-- 个人中心健康档案页面 -->
  <div id="health-file">
    <div class="top-title">
      <img
        src="../../assets/img/login-img/3-1档案-返回ic@2x.png"
        alt=""
        class="back-icon"
        @click="goBack"
      >
      <p class="title-text siyuan-bold">健康档案</p>
      <p class="right-text" v-show="isDelect" @click="isDelect = false">完成</p>
      <div v-if="fileData.length>0">
        <img
          src="../../assets/img/login-img/3-3file-delectic@2x.png"
          alt=""
          class="right-icon"
          @click="isDelect = true"
          v-show="!isDelect"
        >
      </div>
    </div>
    <div class="file-wrapper">
      <ul class="file-box" @touchmove="handleTouchMove">
        <li class="file-item" v-for="(item,index) in fileData" :key="index">
          <div class="select-button-box" v-show="isDelect" @click="onClick(item,index)">
            <img
              src="../../assets/img/login-img/3-4file-select@2x.png"
              alt=""
              class="select-button"
              v-show="delectList.includes(item.id)"
            >
            <img
              src="../../assets/img/login-img/3-4file-noselect.png"
              alt=""
              class="select-button"
              v-show="!delectList.includes(item.id)"
            >
          </div>
          <div class="file-msg-box" @click="goRouter('/SdEditFile',item.id)">
            <img src="../../assets/img/login-img/3-3档案袋@2x.png" alt="" class="bgc-img">
            <div class="file-msg-text">
              <p class="item-text item-name">{{item.name}}</p>
              <p class="item-text item-sex">{{item.sex|sexFilter}}</p>
              <p class="item-text item-age">{{item.age}}岁</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- end -->
    <!-- 缺省页 -->
    <div class="null-wrapper" v-if="fileData.length===0 && showNull">
      <div class="img-wrapper">
        <img src="../../assets/img/queshengye/no-item@2x.png" alt="" class="null-img">
      </div>
      <div class="text-wrapper">
        <span class="null-text">建立档案，深读君才能更好地帮你呀！</span>
      </div>
      <div class="button-wrapper">
        <van-button @click="goAdd" class="null-button" type="primary">新建档案</van-button>
      </div>
    </div>
    <!-- end -->
    <!-- 底部按钮 -->
    <div class="box-bottom" v-if="fileData.length>0">
      <!--阴影 -->
      <div class="bottom-shadow"></div>
      <!-- end -->
      <div class="bottom-button">
        <div class="bottom-left" v-show="isDelect" @click="allSelect">
          <img
            src="../../assets/img/login-img/3-4file-noselect.png"
            alt=""
            class="select-icon"
            v-show="!allSelectFlag"
          >
          <img
            src="../../assets/img/login-img/3-4file-select@2x.png"
            alt=""
            class="select-icon"
            v-show="allSelectFlag"
          >
          <p class="select-text siyuan-bold">全选</p>
        </div>
        <div class="bottom-right">
          <van-button size="large" class="right-button" @click="onSubmit">{{buttonText}}</van-button>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 底部文字 -->
    <div class="bottom-text" v-if="showBottom && fileData.length>0 ">
      <span>深读君等你添加更多的健康档案呦！</span>
    </div>
  </div>
</template>

<script>
  import api from "@/api/index";
  export default {
    data() {
      return {
        fileData: [],
        isDelect: false,
        uid: "",
        delectList: [],
        allSelectFlag: false,
        showBottom: false,
        showNull: false
      };
    },
    updated() {
      this.showTips();
    },
    beforeMount() {
      this.fetch();
    },
    methods: {
      goBack() {
        if (this.$route.query.from) {
          this.$router.push(this.$route.query.from);
        } else {
          this.$router.back(-1);
        }
      },
      goRouter(val, item) {
        this.$router.push({ path: val, query: { healthId: item } });
      },
      onSubmit() {
        // 新增档案
        if (this.buttonText === "新增档案") {
          this.$router.push("SdAddFile");
        } else {
          // 删除档案
          let url = api.deleteHealth;
          let ids = this.delectList.toString();
          let params = {
            ids: ids
          };
          this.$http.post(url, this.$ObjToFd(params)).then(res => {
            if (res.data.code == 0) {
              this.$toast("删除成功");
              this.delectList = [];
              this.fetch();
              this.isDelect = false;
              this.allSelectFlag = false;
            }
          });
        }
      },
      fetch() {
        this.$http.get(api.healthRecords).then(res => {
          if (res.data.code == 0) {
            this.fileData = res.data.data;
            // this.fileData.reverse()
            this.showNull = true;
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      delectFile() {},
      onClick(item) {
        let flag = this.delectList.indexOf(item.id);
        if (flag === -1) {
          this.delectList.push(item.id);
        } else {
          this.delectList.splice(flag, 1);
        }
      },
      allSelect() {
        this.allSelectFlag = !this.allSelectFlag;
        if (this.allSelectFlag) {
          this.delectList.splice(0);
          this.fileData.map((item, index) => {
            this.delectList.push(item.id);
          });
        } else {
          this.delectList.splice(0);
        }
      },
      goAdd() {
        this.$router.push("/SdAddFile");
      },
      // 移动判断
      handleTouchMove() {
        this.showTips();
      },
      showTips() {
        this.showBottom =
          document.documentElement.scrollTop || document.body.scrollTop > 0;
      }
    },
    computed: {
      buttonText() {
        return this.isDelect === false ? "新增档案" : "删除";
      }
    },
    filters: {
      sexFilter(val) {
        return val === "m" ? "男" : "女";
      }
    }
  };
</script>

<style lang="postcss">
  #health-file {
    height: 100%;
    background-color: #fffffd;
    width: 100%;
    padding-bottom: 60px;
    /* background-color: red; */
    & .top-title {
      width: 100%;
      padding: 27px 0;
      position: fixed;
      width: 100%;
      z-index: 999;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #fffffd;
      background-color: #fffffd;
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      & .back-icon {
        width: 17px;
        height: 34px;
        position: absolute;
        left: 30px;
      }
      & .title-text {
        font-size: 34px;
        font-family: "SourceHanSansCN Medium";
        font-weight: 400;
      }
      & .right-text {
        position: absolute;
        right: 30px;
        color: #37bd37;
        font-size: 30px;
      }
      & .right-icon {
        position: absolute;
        right: 30px;
        width: 32px;
        height: 32px;
      }
    }
    & .none-wrapper {
      position: absolute;
      top: 217px;
      & .tips-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        & .none-img {
          width: 254px;
          height: 360px;
          margin-bottom: 50px;
        }
        & .none-text {
          font-size: 30px;
          color: #999999;
          font-family: "SourceHanSansCN Regular";
        }
      }
      & .button-box {
        margin-top: 100px;
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        & .new-button {
          border: 1px solid #d7d7d7;
          border-radius: 40px;
          box-shadow: rgb(0, 0, 0, 0.08) 3px 5px 5px;
          height: 90px;
          font-size: 40px;
        }
      }
    }
    & .file-wrapper {
      width: 100%;
      margin-top: 88px;
      padding: 0 30px;
      box-sizing: border-box;
      display: inline-block;
      padding-bottom: 100px;
      background-color: #fffffd;
      & .file-box {
        width: 100%;
        margin-top: 70px;
        /* background-color: #fffffd; */

        & .file-item {
          font-weight: bold;
          font-size: 42px;
          width: 100%;
          display: flex;
          align-items: center;
          margin-top: 60px;
          & .select-button-box {
            & .select-button {
              width: 40px;
              margin-right: 45px;
            }
          }
          & .file-msg-box {
            width: 100%;
            display: flex;
            justify-content: center;
            position: relative;
            & .bgc-img {
              width: 100%;
              height: 100%;
            }
            /* & .file-msg-text {
              position: absolute;
              height: 60px;
              width: 354px;
              margin-top: 130px;
              display: flex;
              justify-content: space-between;
              border-bottom: 1px #37bd19 solid;
            } */
            & .file-msg-text {
              position: absolute;
              top: 0;
              display: flex;
              top: 50%;
              /* margin-top: 30px; */
              left: -64px;
              /* width: 100%; */
              /* justify-content: space-between; */
              text-align: center;
              margin: 30px 0 0 170px;
              /* border-bottom: 1px #37bd19 solid; */
              padding-bottom: 20px;
              & .item-text {
                /* margin: */
              }
              & .item-name {
                width: 180px;
                /* text-align: left; */
                /* margin-left: 170px; */
              }
              & .item-sex {
                margin-left: 40px;
              }
              & .item-age {
                margin-left: 90px;
              }
            }
          }
        }
      }
    }
    & .null-wrapper {
      display: flex;
      flex-direction: column;
      padding-top: 15px;
      align-items: center;
      & .img-wrapper {
        & .null-img {
          width: 330px;
          height: 330px;
        }
      }
      & .text-wrapper {
        padding-top: 60px;
        font-size: 30px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
      & .button-wrapper {
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        padding-top: 50px;
        & .null-button {
          height: 88px;
          width: 100%;
          background: rgba(255, 255, 253, 1);
          border: 1px solid rgba(215, 215, 215, 1);
          box-shadow: 0px 0px 0px rgba(5px, 5px, 5px, 0.08);
          border-radius: 40px;
          font-size: 32px;
          font-family: SourceHanSansCN-Medium;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
    & .box-bottom {
      position: absolute;
      bottom: 90px;
      width: 100%;
      & .bottom-shadow {
        width: 100%;
        background: url("../../assets/img/common-img/jianbian-xia@2x.png")
          repeat-x;
        height: 73px;
        position: fixed;
        bottom: 88px;
      }
    }
    & .bottom-button {
      width: 100%;
      height: 88px;
      position: fixed;
      bottom: 0;
      margin-top: 88px;
      display: flex;
      border: none;
      background-color: #fffffd;
      & .van-button--default {
        background-color: #fffffd;
        border: none;
      }
      & .bottom-left {
        border-right: 1px solid #d7d7d7;
        font-size: 32px;
        color: #666666;
        width: 220px;
        display: flex;
        align-items: center;
        padding-left: 30px;
        & .select-icon {
          margin-right: 20px;
          width: 40px;
        }
      }
      & .bottom-right {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        & .right-button {
          font-size: 32px;
          color: #37bd19;
          height: 100%;
        }
      }
    }
    & .bottom-text {
      background-color: #fffffd;
      font-size: 24px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 180px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shenduUserInfo/SdHealthFile.vue